import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import BpcPublicMenu from '@cms/components/public-menu/public-menu.vue';
import ModulesHelper from '@core/services/modules.helper';

@Component({
  name: 'bpc-public-header',
  components: {
    BpcPublicMenu,
  },
})
export default class PublicHeader extends Vue {
  @Prop(String) readonly logo: string;
  @Prop(String) readonly name: string;
  @Prop(String) readonly headerImageUrl: string;

  get tenantAlias(): string {
    return this.$clientRouter.getTenantAlias();
  }

  get isCmsModuleActivated(): boolean {
    return this.$modulesService.hasModuleActivated(ModulesHelper.CMS_MODULE_NAME);
  }

  /* Lifecycle hooks */

  // created() {}
  // updated() {}
  // destroyed() {}
}
